module.exports = __webpack_public_path__ + "static/media/light_green_swoop.cee49051.png";